import projectsEpicsMap from "./projects.epics";
import * as projectsReducers from "./projects.reducers";
import { objectValues } from "@ea/shared_components/utils/object";

const projectsEpics = objectValues(projectsEpicsMap);

export { projectsEpics, projectsReducers };
